<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom:60px;">
              <div class="col-xs-12">{{total}}{{$t("message.datagridresult") }}</div>
              <el-table :data="rows" style="width: 100%" border ref="multipleTable" @selection-change="handleSelectionChange" @sort-change="sortChange" @row-dblclick="handleDbClick">
                <el-table-column type="selection" width="55" ></el-table-column>
                <el-table-column prop="roleName" v-bind:label='$t("message.RoleName")' width="200" sortable></el-table-column>
                <el-table-column prop="createdTime" v-bind:label='$t("message.createdTime")' width="170" sortable></el-table-column>
              </el-table>
            </div>
            <div class="col-sm-12 row" style="margin-top:-30px;">
              <div class="pull-right">
                <button
                  class="btn btn-white"
                  @click="gotoDetail"
                   v-if="checkPermission('ROLE_LIST_NEW')"
                >{{$t("message.Add") }}</button>
                <button 
                   class="btn btn-white" 
                   @click="showWarning" 
                   v-if="checkPermission('ROLE_LIST_DELETE')"
                  >{{$t("message.Delete") }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Vue from "vue";
import eventBus from "../eventbus";
import { truncate } from "fs";
import config from "../config";

export default {
  name: "usefulLinksListController",
  mixins: [config.globalMixin],
  components: {
  },
  data() {
    return {
      page: 0,//当前页数
      pagesize:10,//一页显示几条
      filter: "",
      searchName: "",
      searchStatus: null,
      total:0,
      rows:[],
      multipleSelection:[],
      sortType:"ASC",
      sortField:"id",
    };
  },
  created: function() {
    if(this.$route.query.sortField){
      this.sortField = this.$route.query.sortField;
    }
    if(this.$route.query.page){
      this.page = parseInt(this.$route.query.page);
    }
    if(this.$route.query.pagesize){
      this.pagesize = parseInt(this.$route.query.pagesize);
    }
  },
  methods: {
    formatDate(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return d + "/" + MM + "/" + y + " " + h + ":" + m + ":" + s;
    },
    async init() {
      let objdata = this.getAuthObj();

      objdata.apiUrl = '/getSystemRoleAllList'
      var data = await this.$store.dispatch("apiEvent", objdata);
      if(!data) return;
      let list = null;
      this.rows = data.data.result;
      this.total = data.data.result.length;
    },
    gotoDetail() {
      let userInfo = this.$store.state.userInfo;
      this.$router.push({ path: "/main/roleDetail" });
    },
    getStatus(data) {
      if (data.indexOf("all") < 0) {
        this.searchStatus = Number(data);
      } else {
        this.searchStatus = null;
      }
    },
    async search() {
    },
    showWarning() {
      var that = this;
      if (this.multipleSelection.length != 0) {
          this.$store.commit("setwarning", {
            string: this.$i18n.t("message.deleteContent"),
            boolean: true,
            button: [{
              name:this.$i18n.t("message.Confirm"),
              callBack:function(){
                that.deleteList();
              }
            }, {
              name:this.$i18n.t("message.Cancel"),
              callBack:function(){}
            }]
          });
      }
    },
    async deleteList() {
      let ids = [];
      let objdata = this.getAuthObj();
      if (this.multipleSelection.length != 0) {
        for (let i = 0; i < this.multipleSelection.length; i++) {
          ids.push(this.multipleSelection[i].id);
        }
      }
      objdata.roleIds = ids;

      objdata.apiUrl = '/deleteSystemRole'
      var data = await this.$store.dispatch("apiEvent", objdata);
      if(!data) return;
      if (data.data.errorCode === 0) {
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: []
        });
        this.init();
      }
    },
    cancel: function() {
      this.$store.commit("setwarning", { string: "", boolean: false });
    },
    handleSizeChange:function(val){
      this.pagesize = val;
      this.init();
    },
    handleCurrentChange:function(val){
      this.page = val-1;
      this.init();
    },
    handleSelectionChange:function(val){
      this.multipleSelection = val;
    },
    handleDbClick:function(row){
      this.$router.push({
        path: "/main/roleDetail",
        query: { id: row.id }
      });
    },
    sortChange:function(val){
      if(val.order=='ascending'){
        this.sortType = 'ASC';
        this.sortField = val.prop;
      }else if(val.order=="descending"){
        this.sortType = 'DESC';
        this.sortField = val.prop;
      }else{
        this.sortType = 'ASC';
        this.sortField = 'id';
      }
      this.init();
    }
  },
  mounted() {
    this.init();
  }
};
</script>
